/* eslint-disable react/prop-types */
// Copyright (c) 2019 Deere & Company

import './info-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import React from 'react';

export const InfoAlertBar = ({
    alertTitle, canDismiss, dismissHandler,
    timeoutLength, willAutoDismiss, children,
}) => (
    <div className="info-alert-bar">
        <AlertBarBase
            alertTitle={alertTitle}
            canDismiss={canDismiss}
            dismissHandler={dismissHandler}
            iconClass="icon-info-white"
            timeoutLength={timeoutLength}
            willAutoDismiss={willAutoDismiss}
        >
            {children}
        </AlertBarBase>
    </div>
);

InfoAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false,
};
